  // src/components/Theme.js

  import React, { useState, useEffect } from 'react';
  import axios from 'axios'
  import hwt1 from '../assests/images/hwt1.png';
  import hwt3 from '../assests/images/hwt3.png';
  import hwt4 from '../assests/images/hwt4.png';
  import hwt5 from '../assests/images/hwt5.png';
  import hwt6 from '../assests/images/hwt6.png';
  import hwt7 from '../assests/images/hwt7.png';
  import hwt8 from '../assests/images/hwt8.png';
  import hwt9 from '../assests/images/hwt9.png';
  import hwt10 from '../assests/images/hwt10.png';
  import hwt11 from '../assests/images/hwt11.png';
  import hwt13 from '../assests/images/hwt13.png';
  import hwt15 from '../assests/images/hwt15.png';
  import hwt19 from '../assests/images/hwt19.png';
  import hwt20 from '../assests/images/hwt20.png';
  import hwt21 from '../assests/images/hwt21.png';
  import hwt22 from '../assests/images/hwt22.png';
  import hwt23 from '../assests/images/hwt23.png';
  import hwt25 from '../assests/images/hwt25.png';
  import hwt26 from '../assests/images/hwt26.png';
  import ImageModal from './ImageModal'; // Make sure to import ImageModal  
  const Theme = () => {
    const [showModal, setShowModal] = useState(false);
    const [activeImage, setActiveImage] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const [whatt , setWhat] = useState([
      {img:hwt1}, {img:hwt3}, {img:hwt4}, {img:hwt5},
      {img:hwt6}, {img:hwt7}, {img:hwt8}, {img:hwt9}, {img:hwt10},
      {img:hwt11}, {img:hwt13}, {img:hwt15}, {img:hwt19}, {img:hwt20},
      {img:hwt21}, {img:hwt22}, {img:hwt23}, {img:hwt25},
      {img:hwt26}
    ])
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get('https://clientserver-production-f8b8.up.railway.app/api/thums?populate=*');
          const apiData = response.data.data;
  
          const transformedData = apiData.map(item => ({
            img: 'https://clientserver-production-f8b8.up.railway.app' + item.attributes.image.data.attributes.url,
          }));
          setWhat(prevData => {
            // Check if the data already exists
            const newEntries = transformedData.filter(
              newItem => !prevData.some(item => item.img === newItem.img )
            );
            return [...prevData, ...newEntries];
          });
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, []);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      window.addEventListener('resize', handleResize);
      handleResize(); // Initial check
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    const handleImageClick = (image) => {
      if (!isMobile) {
        setActiveImage(image);
        setShowModal(true);
      }
    };
  
    return (
      <div>
        <div 
          id='Portfolio'
          data-aos="fade-right"
          data-aos-duration='2000'  
          className='flex justify-center items-center flex-col mt-[200px]'
        >
          <div>
            <p className='text-border text-[#C0392B] text-lg text-center md:text-5xl uppercase border-2 border-[#C0392B] rounded-lg shadow-[#C0392B] shadow-lg p-2'>
              Our recent project on thumbnails
            </p>
          </div>
          <div 
            className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2 md:grid-cols-3'} gap-5 w-[380px] md:w-auto mx-[100px] mt-10 group`}
          >
            {whatt.map((what, index) => (
              <div 
                key={index} 
                className="relative"
                data-aos="fade-up"
                data-aos-duration='2000'
                onClick={() => handleImageClick(what)}
              >
                <img 
                  src={what.img} 
                  alt="here" 
                  className="w-[450px] rounded-lg shadow-md group-hover:blur-lg hover:!blur-none border border-[#C0392B]" 
                />
              </div>
            ))}
          </div>
        </div>
        {showModal && <ImageModal image={activeImage} setShowModal={setShowModal} />}
      </div>
    );
  };
  
  export default Theme;